export default __webpack_public_path__ + "static/media/water.96d498a2.jpg";